import { MeetingMinutesISO8601Duration } from '@libs/src/calendar/calendar.types';
import { Group } from '@libs/src/models/group.model';
import { Tenant } from '@libs/src/tenant/tenant.interface';

import toNumber from 'lodash-es/toNumber';

export function parseDurationFromISO8601String(
  duration: MeetingMinutesISO8601Duration,
) {
  const durationString = duration?.match(/[^T]+(?=M)/);
  return toNumber(durationString);
}

export function isCalendarIntegrationEnabledForHub(
  provider: Group['integrations']['calendar']['provider'],
  tenant: Tenant,
  group: Group,
): boolean {
  if ('microsoft' !== provider) {
    return false;
  }
  return (
    !!tenant.integrations?.calendar?.microsoft?.client_id &&
    'microsoft' === group.integrations?.calendar?.provider
  );
}
